<template>
  <div id="navHanger">
    <div
      v-for="indicator in indicators"
      :key="indicator.id"
      :id="'live-now-indicator-' + indicator.id"
      class="liveNowWrapper"
      :aria-label="'Live Now Indicator: ' + indicator.name"
    >
      <div
        v-for="agendaItem in indicator.agendaItems"
        :key="agendaItem.id"
        :data-start-datetime="agendaItem.start_datetime"
        :data-end-datetime="agendaItem.end_datetime"
        :data-id="agendaItem.id"
        :data-user-timezone="userTimezone"
        :data-event-timezone="eventTimezone"
        class="liveNowIndicator"
      >
        <a :href="'/main-stage/' + indicator.main_stage_id">Live Now</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      indicators: [],
      userTimezone: "",
      eventTimezone: "",
    };
  },
  created: function () {
    const today = moment();
    $.ajax({
      type: "POST",
      url: "/live-now-indicators",
      data: {
        scheduled_dates: [
          today.subtract(1, "days").format("YYYY-MM-DD"),
          today.format("YYYY-MM-DD"),
          today.add(1, "days").format("YYYY-MM-DD"),
        ],
      },
      success: (res) => {
        const keys = Object.keys(res.indicators);
        keys.forEach((key) => this.indicators.push(res.indicators[key]));
        this.userTimezone = res.user_timezone;
        this.eventTimezone = res.event_timezone;
        this.setDates();
        this.checkTimes();
        const self = this;
        setInterval(function () {
          self.checkTimes();
        }, 3000);
      },
    });
  },
  methods: {
    checkTimes() {
      let now = moment().tz(this.eventTimezone).format("YYYY-MM-DD HH:mm:ss");

      $(".liveNowIndicator").each(function () {
        let startDateTime = $(this).attr("data-start-datetime");
        let endDateTime = $(this).attr("data-end-datetime");

        let itemStart = moment(startDateTime).format("YYYY-MM-DD HH:mm:ss");
        let itemEnd = moment(endDateTime).format("YYYY-MM-DD HH:mm:ss");

        if (moment(now, "YYYY-MM-DD HH:mm:ss").isAfter(itemEnd)) {
          $(this).addClass("expired").removeClass("live");
        } else if (moment(now, "YYYY-MM-DD HH:mm:ss").isAfter(itemStart)) {
          $(this).addClass("live");
        }

      });

      // If at least a single item is live, add a helper class to the header to allow for more frontend flexibility
      if ($(".liveNowIndicator.live").length) {
        $("header").addClass("live");
      } else {
        $("header").removeClass("live");
      }
    },
    setDates() {
      this.indicators.forEach(indicator => {
        indicator.agendaItems.forEach(agendaItem => {
          agendaItem.start_date = agendaItem.scheduled_date;
          agendaItem.end_date = agendaItem.end_datetime.split(" ")[0];
        })
      })
    }
  },
};
</script>

<style>
</style>